// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_Arz","cls2":"PaperAbstract-cls2_6B4 PaperAbstract-cls1_Arz","isSnippet":"PaperAbstract-isSnippet_hYh","variant-dense":"PaperAbstract-variant-dense_zHx"};